import React, {useState, useEffect} from 'react'

import { Center, Box, Text, Image, Stack, Heading, Button, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure, Input} from "@chakra-ui/react"

import imgMaria from './res/maria-rose.jpg'
import axios from 'axios';
import CountUp from 'react-countup';

const HomeRosa = () => {
    const [nome, setNome] = useState("");
    const [citta, setCitta] = useState("");
    const [contatore, setContatore] = useState(0);
    const [preghiereOggi, setPreghiereOggi] = useState([]);

    const { isOpen, onOpen, onClose } = useDisclosure()
    const { isOpen:isOpenLista, onOpen:onOpenLista, onClose:onCloseLista } = useDisclosure()

    const toast = useToast()

    const settaContatore = () => {

        axios.get('https://www.recode.digital/una-rosa-per-maria/server_rosa/public/preghiere')
            .then(function (response) {
                if(response.data.length > 0) {
                    setContatore(response.data.length);
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    const getPreghiereOggi = () => {

        axios.get('https://www.recode.digital/una-rosa-per-maria/server_rosa/public/getPreghiereOggi')
            .then(function (response) {
                if(response.data.length > 0) {
                    setPreghiereOggi(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    useEffect(() => {

        settaContatore();
        getPreghiereOggi();
        
    }, [])


    const postPreghiera = () => {

        // let visibilita = visibile ? "1" : "0";
        
        let data = new FormData();
        data.append('nome', nome);
        data.append('citta', citta);

        let noEmpty = true;
        for (var value of data.values()) {
            if (value === ''){
                noEmpty = false;
            }
        }

        if(noEmpty){
            axios.post('https://www.recode.digital/una-rosa-per-maria/server_rosa/public/preghiere', data)
            .then(function (response) {
                console.log(response);
                if(response.data.error === null){
                    toast({
                        title: "La tua preghiera è stata conteggiata!",
                        description: "Il tuo impegno di preghiera è stato conteggiato insieme agli altri!",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    })

                    setNome("")
                    setCitta("");
                    onClose();
                    settaContatore();
                    getPreghiereOggi();
                }
            })
            .catch(function (error) {
                console.log(error);
                toast({
                    title: "Errore",
                    description: "Non è stato possibile conteggiare il tuo impegno di preghiera. Riprova fra qualche istante.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                })
            });
        }
        else{
            toast({
                title: "Dati mancanti",
                description: "Devi aggiungere tutti i dati prima di poter inviare.",
                status: "info",
                duration: 3000,
                isClosable: true,
            })

        }
        
    }


    return (
        <>
        <Center mt={100}  >
            <Stack maxW={"1000px"} align="center">
            <Heading mt={5} mb={5}>Una Rosa per Maria 🌹</Heading>
            <Image
                src={imgMaria}
                mb={5}
            />
            <Text as="i" mb={5} px={10}>
                Credo fermamente che tutta questa vicenda del virus sia <b>un'occasione di conversione</b>, comunque la si pensi sulla malattia, sulla gestione, sulla pressione mediatica che non rende facile mantenere il cuore lieto e nella pace. Mi chiedo continuamente: cosa vuole dirmi il Signore, come permette che mi converta in questa circostanza, qui e adesso?<br></br>
            </Text>
            <Text>Rose offerte a Maria fino ad oggi:</Text>
            <Heading mb={5}>
                <CountUp
                    start={0}
                    end={contatore}
                    duration={4}
                    suffix=" 🌹"
                ></CountUp>
            </Heading>
            <Button onClick={()=> onOpenLista()} mb={5} py={5} colorScheme="teal" w={"80%"} variant="solid" style={{whiteSpace: "normal", wordWrap: "break-word"}}>
                Scopri chi ha pregato oggi con te
            </Button>
            <Button onClick={()=> onOpen()} mb={5} py={5} colorScheme="teal" height={20} w={"80%"} variant="solid" style={{whiteSpace: "normal", wordWrap: "break-word"}}>
                Clicca qui per confermare di aver compiuto oggi il tuo impegno di preghiera 🙏🏻
            </Button>
            <Text mt={10} mb={5} px={10}>
                Sono certa che sia prima di tutto un grande invito alla preghiera, un poderoso pro memoria che ci ricorda che nulla dipende da noi, neanche il numero dei capelli che ci cadranno oggi, nulla. Non la malattia, non i rischi del vaccino, non il potere di cambiare la narrazione e le leggi, nulla. Dio invece può tutto, nelle sue mani un giorno sono come mille anni, e ci ha promesso che <b><i>“se due di voi sopra la terra si accorderanno per domandare qualunque cosa, il Padre mio che è nei cieli ve la concederà”.</i></b><br></br>
                Così, pensando alle tante amiche tentate dallo scoraggiamento e dalla paura o dalla rabbia, ci è venuto in mente di formare un piccolo gruppo, che abbiamo chiamato La dieci, ricordando che Dio aveva accordato ad Abramo la promessa di risparmiare Sodoma e Gomorra se solo avesse trovato dieci giusti. Ora, io so bene che noi non siamo giuste, di sicuro non io, però quello era l'Antico Testamento, e noi oggi abbiamo la grazia di Cristo che ci ha redente, quindi osiamo. <b>Osiamo chiedere, offrendo noi stesse, il cuore e il tempo, che il Padre ci liberi, noi, le nostre famiglie, e tutti,</b> anche quelli che ci sono antipatici, tutti. Supplichiamo la grazia.<br></br>
                Tante persone dopo il mio post mi hanno chiesto come fare concretamente per essere in comunione, allora ho pensato questo.<br></br>
            </Text>
            <Button onClick={()=> onOpen()} mb={5} py={5} colorScheme="teal" height={20} w={"80%"} variant="solid" style={{whiteSpace: "normal", wordWrap: "break-word"}}>
                Clicca qui per confermare di aver compiuto oggi il tuo impegno di preghiera 🙏🏻
            </Button>
            <Text mb={5} px={10}>
                <b>Per il periodo dal 5 agosto (compleanno di Maria) all'8 settembre (natività)</b> ognuno di noi, o in gruppo o anche da solo, <b>pensi cosa offrire.</b> Un impegno che sia possibile mantenere, ragionevolmente. Per esempio un rosario al giorno, o anche due. E un fioretto. Piccolo, magari, perché si spera che molti di noi siano in vacanza e anche il corpo ha diritto al suo riposo. Che so, un caffè in meno. Rimandare di un'oretta la lattina di Coca. Una piccola cosa, ma ogni giorno. Se non la si vuole condividere tra amiche, che almeno per me è un grande aiuto a cercare di tenere fede, lo si può scrivere su un foglietto da mettere sotto un'immagine sacra.<br></br>
                Poiché molti di voi non hanno un gruppo con cui condividere, ho chiesto al caro amico Emanuele Ercoli di predisporre un semplice contatore, per farci coraggio, e per aiutarci nella perseveranza.<br></br>
                <b>Ogni giorno</b>, quando avrai fatto quello che avevi promesso (contano anche i rosari in cui ti addormenti, ché li finiscono gli angeli in cielo, lo diceva mia nonna, nota teologa), cioè una preghiera e un fioretto, <b>puoi cliccare per aggiungere una rosa al mazzo che porteremo alla Madonna l'8 settembre,</b> chiedendole di aiutarci a somigliare a lei, accogliendo Gesù in noi.
            </Text>
            <Text>Rose offerte a Maria fino ad oggi:</Text>
            <Heading mb={5}>
                <CountUp
                    start={0}
                    end={contatore}
                    duration={4}
                    suffix=" 🌹"
                ></CountUp>
            </Heading>
            <Button onClick={()=> onOpenLista()} mb={5} py={5} colorScheme="teal"  w={"80%"} variant="solid" style={{whiteSpace: "normal", wordWrap: "break-word"}}>
                Scopri chi ha pregato oggi con te
            </Button>
            <Button onClick={()=> onOpen()} mb={5} py={5} colorScheme="teal" height={20} w={"80%"} variant="solid" style={{whiteSpace: "normal", wordWrap: "break-word"}}>
                Clicca qui per confermare di aver compiuto oggi il tuo impegno di preghiera 🙏🏻
            </Button>

            </Stack>
            
        </Center>

        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent mx={5}>
            <ModalHeader>Conferma il tuo impegno di preghiera</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <Text mb="8px">Il tuo nome di Battesimo:</Text>
                <Input
                    value={nome}
                    onChange={(e)=>{setNome(e.target.value)}}
                    placeholder=""
                    size="sm"
                />
                <Text mb="8px" mt={3}>La tua città:</Text>
                <Input
                    value={citta}
                    onChange={(e)=>{setCitta(e.target.value)}}
                    placeholder=""
                    size="sm"
                />
            </ModalBody>
            <ModalFooter>
                <Button mr={2} onClick={onClose}>Annulla</Button>
                <Button onClick={()=>{postPreghiera();}} colorScheme="teal">Invia</Button>
            </ModalFooter>
            </ModalContent>
        </Modal>

        {preghiereOggi.length > 0 && (

            <Modal onClose={onCloseLista} isOpen={isOpenLista} isCentered>
                <ModalOverlay />
                <ModalContent mx={5}>
                <ModalHeader>Chi ha pregato con te oggi</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {preghiereOggi.map(preghiera => (
                        <Text>• {preghiera.nome} - {preghiera.citta}</Text>
                    ))}
                </ModalBody>
                <ModalFooter>
                    <Button mr={2} onClick={onCloseLista}>Chiudi</Button>
                </ModalFooter>
                </ModalContent>
            </Modal>

        )}

        

        </>
    )
}

export default HomeRosa
